import SceButton from '../../../../../../../../Common/CommonComponents/sceButton.js';
import SceTextBoxComponent from '../../../../../../../../Common/TextBox/sceText.js';
import classes from './editPhoneDialogBox.scss';
import { getLocalizedStrings } from './popUpCommonStrings.js';
import RadioGroup from '../../../../../../../../Common/CommonComponents/radioButton.js';
import Modal from 'react-awesome-modal';
/***********************
Change type : Security changes for phone numbers
Changed by: Sai Aman Pothuganti
Date : 06-10-2020
************************/
import GlobalErrorBlock from '../../../../../../../../Common/CommonComponents/GlobalErrorBlock/globalErrorBlock';
import ErrorStrings from '../../../errorStrings';

const EditPhoneDialogBox = (props) => {
  const strings = getLocalizedStrings('addEmailDialog');
  const loadingSpinner = props.showSpinner ? <div className={classes.sceRightIcon}>
  <i className='fa fa-spinner fa-spin' /></div> : null ;
  // var [, , lastFourDigit] = EditPhoneNumber.split('-');
  return (
  <div className={classes.scrollDiv}>
    <Modal
      visible='true'
      effect="fadeInUp"
      width="100%" 
      height="100%">
    <div className={classes.sceAddEmailDialog}>
      <div className={'row ' + classes.sceAddEmailDialogWrap}>
        <div className={'col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 ' + classes.sceAddEmailDialogMain}>
          <div className={classes.sceCancelDialogSection}>
          {props.isLocalError ? <GlobalErrorBlock errorMessage={ErrorStrings["DEFAULT"]} /> : null}
            <div className={classes.sceCancelDialogInfo}>
              <div className={classes.sceDialogMainContent}>{strings.editVoiceHeading}</div>
              <div className={classes.sceDialogNote}>{strings.editVoiceNote}</div>
              {/* <div className={classes.sceEditNumber}>{app.appUtil.maskPhoneNumberWithhyphenX(app.appUtil.formatPhoneNumber(props.deleteValue))}</div> */}
              <div className={classes.sceTextBoxData}>
                <SceTextBoxComponent 
                  id='editPhoneNum' type='cppResPhone' maxLength={13} 
                  placeholder={props.deleteValue} 
                  validator={app.appUtil.validator} 
                  //defaultValue={app.appUtil.formatPhoneNumber(props.deleteValue)}
                  onTextUpdatedHandler={props.retrievedataFromTextBoxes}
                  isError={props.editPhoneNum.isError}
                  isValid={props.editPhoneNum.isValid}
                  errorMsg={props.editPhoneNum.errorMsg}
                  value={props.editPhoneNum.value}
                /> 
                {loadingSpinner}
              </div>
              <div className={classes.sceRadio}>
                {props.options.map((email, i) => {
                  return (
                    <div key={'radio' + i}>
                      <RadioGroup
                        setName={'editPhoneRadioOptions'}
                        options={[props.options[i]]}
                        type='radio'
                        validStyle={props.selectedOptionValidStyle}
                        radioOutLineFlag={props.radioOutline}
                        selectedOptions={props.selectedOptions}
                        onClick={(event) => props.onMobileRadioClick(event, i)}
                      // onFocus={(event) => props.onRadioFocus(event, i)}

                      />


                      {/* <ForceValidateBlock forceValidate={props.phonetypeError && _.isEmpty(props.selectedOptions)} /> */}
                    </div>

                  );
                })
                }
              </div>



            </div>
            <div className={'row ' + classes.sceCancelDialogActions}>
              <div className={'col-xs-12 col-sm-6 col-sm-push-6 ' + classes.sceConfirmBtn}>

                <SceButton
                  id='cancelDialogYes'
                  buttonType={props.editPhoneNum.value==="" || props.editPhoneNum.isError || props.selectedOptions === '' || props.isLocalError || props.showSpinner ? 'default' : 'sceSmPrimary'}
                  value={strings.btnConfirm}
                  responive='false'
                  isDisabled={props.selectedOptions === ''}
                  onClick={props.editPhoneNum.value==="" || props.selectedOptions === '' || props.isLocalError || props.showSpinner ? (e)=>e.preventDefault() : props.onEditPhoneConfirmDialogClick}
                />
              </div>

              <div className={'col-xs-12 col-sm-6 col-sm-pull-6 ' + classes.sceCancelBtn}>
                <SceButton
                  id='cancelDialogNo'
                  buttonType='sceClose'
                  value={<span id={'cancelDialogno'}>{strings.btnCancel}</span>}
                  responive='false'
                  onClick={(e) => props.onCancelClickHandler(e)}
                  iconType='cancel'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </Modal>
  </div>

  );
};
export default EditPhoneDialogBox;